module.exports = __webpack_public_path__ + "media/images/cat3-4cca0d32cbe6d8a40e51537c2a8f5db0.png";